import { render } from "./SitePermissions.vue?vue&type=template&id=7780e2fc&scoped=true"
import script from "./SitePermissions.vue?vue&type=script&lang=js"
export * from "./SitePermissions.vue?vue&type=script&lang=js"

import "./SitePermissions.vue?vue&type=style&index=0&id=7780e2fc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7780e2fc"]])

export default __exports__